export default __webpack_public_path__ + "static/media/location.bab3a4ce.svg";